import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";
import siteConfig from "../siteConfig";

function Footer() {
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-grid">
        <div className="footer-brand">
          <img
            className="footer-logo"
            src="/head/teingshome-logo-light.svg"
            alt="teingshome"
          />
          <p>{siteConfig.description}</p>
        </div>
        <div>
          <h3>HELP</h3>
          <Link to="/contact" onClick={toTop}>
            Contact us
          </Link>
          <Link to="/shipping" onClick={toTop}>
            Shipping & delivery
          </Link>
          <Link to="/returns" onClick={toTop}>
            Returns & exchanges
          </Link>
          <Link to="/faqs" onClick={toTop}>
            FAQs
          </Link>
        </div>
        <div>
          <h3>POLICIES</h3>
          <Link to="/privacy" onClick={toTop}>
            Privacy policy
          </Link>
          <Link to="/cookies" onClick={toTop}>
            Cookie policy
          </Link>
          <Link to="/terms" onClick={toTop}>
            Terms & conditions
          </Link>
        </div>
        <div>
          <h3>VISIT</h3>
          <p>{siteConfig.legalName}</p>
          <p>{siteConfig.contact.address}</p>
          <a href={`mailto:${siteConfig.contact.email}`}>
            {siteConfig.contact.email}
          </a>
        </div>
      </div>
      <div className="footer-bottom">
        <span>
          © {new Date().getFullYear()} {siteConfig.displayName} ·{" "}
          {siteConfig.legalName}
        </span>
        <div className="payment-methods" aria-label="Supported payment methods">
          <span>VISA</span>
          <span>Mastercard</span>
          <span>AMEX</span>
          <span>Apple Pay</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
